'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _htmlTruncate = require('html-truncate');

var _htmlTruncate2 = _interopRequireDefault(_htmlTruncate);

var _TextArea = require('../../components/TextArea');

var _TextArea2 = _interopRequireDefault(_TextArea);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Title = require('./components/Title');

var _Title2 = _interopRequireDefault(_Title);

var _LeftColumn = require('./components/LeftColumn');

var _LeftColumn2 = _interopRequireDefault(_LeftColumn);

var _RightColumn = require('./components/RightColumn');

var _RightColumn2 = _interopRequireDefault(_RightColumn);

var _CollapseToggle = require('./components/CollapseToggle');

var _CollapseToggle2 = _interopRequireDefault(_CollapseToggle);

var _Image = require('./components/Image');

var _Image2 = _interopRequireDefault(_Image);

var _DownloadButton = require('./components/DownloadButton');

var _DownloadButton2 = _interopRequireDefault(_DownloadButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
# Content Card
A card that can be collapsible or have a download button, but always has a title & some copy.
 */
var ContentCard = function (_React$Component) {
  _inherits(ContentCard, _React$Component);

  function ContentCard(props) {
    _classCallCheck(this, ContentCard);

    var _this = _possibleConstructorReturn(this, (ContentCard.__proto__ || Object.getPrototypeOf(ContentCard)).call(this, props));

    var collapsible = props.collapsible;

    var truncatedCopy = (0, _htmlTruncate2.default)(props.copy, 140) || '';

    _this.copy = props.copy;
    _this.collapsedCopy = truncatedCopy.substring(0, truncatedCopy.lastIndexOf(' ')) + '...';

    _this.state = {
      isCollapsed: collapsible
    };

    _this.toggleCollapse = _this.toggleCollapse.bind(_this);
    return _this;
  }

  // Method to check if the image is valid
  // eslint-disable-next-line class-methods-use-this


  _createClass(ContentCard, [{
    key: 'hasImage',
    value: function hasImage(image) {
      return image && image.trim() !== ''; // Check if the image exists and is not an empty string
    }
  }, {
    key: 'toggleCollapse',
    value: function toggleCollapse() {
      this.setState({
        isCollapsed: !this.state.isCollapsed
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          collapsible = _props.collapsible,
          _props$hasTopMargin = _props.hasTopMargin,
          hasTopMargin = _props$hasTopMargin === undefined ? true : _props$hasTopMargin,
          _props$hasBottomMargi = _props.hasBottomMargin,
          hasBottomMargin = _props$hasBottomMargi === undefined ? true : _props$hasBottomMargi,
          _props$file = _props.file,
          file = _props$file === undefined ? null : _props$file,
          _props$image = _props.image,
          image = _props$image === undefined ? null : _props$image,
          _props$title = _props.title,
          title = _props$title === undefined ? '' : _props$title,
          _props$imageAlt = _props.imageAlt,
          imageAlt = _props$imageAlt === undefined ? null : _props$imageAlt;
      var isCollapsed = this.state.isCollapsed;


      var showExpandedContent = !isCollapsed && collapsible || !collapsible;

      return _react2.default.createElement(
        _Wrapper2.default,
        {
          $hasTopMargin: hasTopMargin,
          $hasBottomMargin: hasBottomMargin
        },
        _react2.default.createElement(
          _LeftColumn2.default,
          {
            $hasImage: this.hasImage(image)
          },
          this.hasImage(image) && _react2.default.createElement(_Image2.default, {
            src: image,
            alt: imageAlt
          }),
          title && !this.hasImage(image) && _react2.default.createElement(_Title2.default, {
            label: title,
            $showOnDesktop: true,
            $showOnMobile: true,
            $hasImage: !this.hasImage(image)
          })
        ),
        _react2.default.createElement(
          _RightColumn2.default,
          null,
          title && this.hasImage(image) && _react2.default.createElement(_Title2.default, {
            $showOnDesktop: this.hasImage(image),
            $showOnMobile: false,
            label: title,
            $hasImage: false
          }),
          !showExpandedContent && _react2.default.createElement(_TextArea2.default, {
            htmlString: this.collapsedCopy
          }),
          showExpandedContent && _react2.default.createElement(_TextArea2.default, {
            htmlString: this.copy
          }),
          showExpandedContent && file && _react2.default.createElement(_DownloadButton2.default, {
            file: file
          }),
          collapsible && _react2.default.createElement(
            _CollapseToggle2.default,
            {
              onClick: this.toggleCollapse
            },
            isCollapsed ? 'Read More' : 'Read Less'
          )
        )
      );
    }
  }]);

  return ContentCard;
}(_react2.default.Component);

ContentCard.propTypes = {
  /** Whether or not a 30px bottom margin is applied. */
  hasBottomMargin: _propTypes2.default.bool,
  /** Whether or not a 30px top margin is applied. */
  hasTopMargin: _propTypes2.default.bool,
  /** copy to render inside the card */
  copy: _propTypes2.default.string.isRequired,
  /** should the card be collapsible or not? */
  collapsible: _propTypes2.default.bool.isRequired,
  /** a title for the card */
  title: _propTypes2.default.string.isRequired,
  /** a url for an image to display in the card */
  image: _propTypes2.default.string,
  /** alt-text for card image */
  imageAlt: _propTypes2.default.string,
  /** a url for a file to be downloaded */
  file: _propTypes2.default.string
};

ContentCard.displayName = 'ContentCard';

exports.default = ContentCard;
ContentCard.__docgenInfo = {
  'description': '# Content Card\r\nA card that can be collapsible or have a download button, but always has a title & some copy.',
  'methods': [{
    'name': 'hasImage',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'image',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'toggleCollapse',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }],
  'displayName': 'ContentCard',
  'props': {
    'hasBottomMargin': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px bottom margin is applied.'
    },
    'hasTopMargin': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px top margin is applied.'
    },
    'copy': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'copy to render inside the card'
    },
    'collapsible': {
      'type': {
        'name': 'bool'
      },
      'required': true,
      'description': 'should the card be collapsible or not?'
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'a title for the card'
    },
    'image': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a url for an image to display in the card'
    },
    'imageAlt': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'alt-text for card image'
    },
    'file': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a url for a file to be downloaded'
    }
  }
};